export { TabController, type TabControllerProps, type Tab } from './TabController';
export { default } from './TabController';

